import { Link } from "react-router-dom";
import type { ReactNode } from "react";

export type Crumb = {
  label: string;
  to?: string;
  icon?: string;
};

type Props = {
  items: Crumb[];
  children?: ReactNode;
};

export default function Breadcrumbs({ items, children }: Props) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-sm">
      <Link to="/" className="flex items-center gap-1 text-foreground-600 hover:text-primary-700">
        <i className="ri-home-4-line"></i>
        首页
      </Link>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-foreground-400"></i>
          {item.to ? (
            <Link to={item.to} className="text-foreground-600 hover:text-primary-700">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900">{item.label}</span>
          )}
        </span>
      ))}
      {children}
    </nav>
  );
}